import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-3 col-sm-6" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = { value: null }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-lg-4 col-sm-6" }
const _hoisted_10 = { class: "form-group mb-4" }
const _hoisted_11 = { value: null }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-lg-3 col-sm-6" }
const _hoisted_14 = { class: "form-group mb-4" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-lg-3 col-sm-6" }
const _hoisted_17 = { class: "form-group mb-4" }
const _hoisted_18 = { class: "col-lg-3 col-sm-6" }
const _hoisted_19 = { class: "form-group mb-4" }
const _hoisted_20 = { value: null }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "col-lg-6 col-sm-6 text-end mt-4" }
const _hoisted_23 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }
const _hoisted_24 = { class: "default-table-area style-two default-table-width" }
const _hoisted_25 = { class: "table-responsive" }
const _hoisted_26 = { class: "table align-middle" }
const _hoisted_27 = { class: "text-body" }
const _hoisted_28 = { class: "text-body" }
const _hoisted_29 = { class: "text-body text-center" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "text-body" }
const _hoisted_32 = { class: "text-body" }
const _hoisted_33 = { class: "text-body" }
const _hoisted_34 = { class: "text-body" }
const _hoisted_35 = { class: "p-4 pt-lg-4" }
const _hoisted_36 = {
  id: "mdlPayerComplaints",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlPayerComplaintsLabel",
  "aria-hidden": "true",
  size: "large"
}
const _hoisted_37 = { class: "modal-dialog modal-lg" }
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = { class: "modal-body" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-lg-5 col-sm-3" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "col-lg-6 col-sm-6" }
const _hoisted_44 = { class: "form-group mb-4" }
const _hoisted_45 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_46 = { class: "form-group mb-4" }
const _hoisted_47 = ["value"]
const _hoisted_48 = {
  key: 0,
  class: "input-error"
}
const _hoisted_49 = {
  key: 1,
  class: "form-group mb-4"
}
const _hoisted_50 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_b_label = _resolveComponent("b-label")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label text-secondary strong" }, "Torneo", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.tournamentId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getMatchesByTournament()))
                  }, [
                    _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTournament, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_8))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.tournamentId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label text-secondary strong" }, "Partido", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.matchId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsMatch, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_12))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.matchId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label text-secondary" }, "Jugada", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.playName) = $event)),
                    class: "form-control h-55",
                    placeholder: "Ingrese nombre de la Jugada"
                  }, null, 512 /* NEED_PATCH */), [
                    [
                      _vModelText,
                      _ctx.filters.playName,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label text-secondary" }, "Jugador", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.playerName) = $event)),
                    class: "form-control h-55",
                    placeholder: "Ingrese nombre del Jugador"
                  }, null, 512 /* NEED_PATCH */), [
                    [
                      _vModelText,
                      _ctx.filters.playerName,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label text-secondary" }, "Estado", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.playStatusId) = $event)),
                    class: "form-select form-control h-55",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPlayStatus, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id,
                        key: i
                      }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_21))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.playStatusId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.getPlayerComplaints(_ctx.currentPage)), ["prevent"])),
                    class: "btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                  }, " Buscar ")
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("table", _hoisted_26, [
              _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "#"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Torneo"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Partido"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Jugada"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Jugador"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Estado"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Creado"),
                    _createElementVNode("br"),
                    _createTextVNode(" por ")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode("creación")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Modificado "),
                    _createElementVNode("br"),
                    _createTextVNode("por")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode(" modificación ")
                  ])
                ])
              ], -1 /* HOISTED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1 + (_ctx.currentPage - 1) * _ctx.pageSize), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_27, _toDisplayString(item.tournament.name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(item.match.name), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.play.name), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.player.fullName), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_29, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (
                      item.status === _ctx.PC_REGISTRADO &&
                        _ctx.changeStatus(item.id, item.reason.name, item.comment)
                    ),
                        class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeStatusClass(item.status)]),
                        role: "button",
                        style: _normalizeStyle({
                      cursor:
                        item.status === _ctx.PC_REGISTRADO ? 'pointer' : 'default',
                      pointerEvents:
                        item.status === _ctx.PC_REGISTRADO ? 'auto' : 'none',
                    })
                      }, _toDisplayString(item.statusDescriptionFinal), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_30)
                    ]),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(item.createdBy), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(item.createdAtDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(item.updatedBy), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_34, _toDisplayString(item.updatedAtDateTimeString), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_Pagination, {
              currentPage: _ctx.currentPage,
              pageSize: _ctx.pageSize,
              totalItems: _ctx.totalItems,
              "onUpdate:page": _ctx.fetchPage
            }, null, 8 /* PROPS */, ["currentPage", "pageSize", "totalItems", "onUpdate:page"])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "mdlPayerComplaintsLabel"
            }, " Evaluar Denuncia "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "label text-secondary strong" }, "Evidencia:", -1 /* HOISTED */)),
                _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _createElementVNode("img", {
                  src: `${_ctx.api_url}/${_ctx.formPlayerComplaint.multimedia}`,
                  alt: "Evidencia",
                  width: "auto"
                }, null, 8 /* PROPS */, _hoisted_42)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "label text-secondary strong" }, "Motivo:", -1 /* HOISTED */)),
                  _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                  _createVNode(_component_b_label, { class: "label" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formPlayerComplaint.reasonName), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                (_ctx.formPlayerComplaint.comment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "label text-secondary strong" }, "Comentario:", -1 /* HOISTED */)),
                      _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                      _withDirectives(_createElementVNode("textarea", {
                        rows: "5",
                        style: {"resize":"none"},
                        class: "form-control text-dark no-resize",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formPlayerComplaint.comment) = $event)),
                        disabled: "true"
                      }, null, 512 /* NEED_PATCH */), [
                        [
                          _vModelText,
                          _ctx.formPlayerComplaint.comment,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_46, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", { class: "label text-secondary strong" }, "Estado", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formPlayerComplaint.status) = $event)),
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.clearError('status'))),
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example"
                  }, [
                    _cache[25] || (_cache[25] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPlayStatusUpdate, (playStatus, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: playStatus.id,
                        key: i
                      }, _toDisplayString(playStatus.name), 9 /* TEXT, PROPS */, _hoisted_47))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.formPlayerComplaint.status]
                  ]),
                  (_ctx.errors.status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.errors.status), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                (_ctx.formPlayerComplaint.status == _ctx.PC_RECHAZADO)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _cache[27] || (_cache[27] = _createElementVNode("label", { class: "label text-secondary strong" }, "Razón de rechazo:", -1 /* HOISTED */)),
                      _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                      _withDirectives(_createElementVNode("textarea", {
                        rows: "5",
                        style: {"resize":"none"},
                        class: "form-control text-dark no-resize",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formPlayerComplaint.rejectionReason) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [
                          _vModelText,
                          _ctx.formPlayerComplaint.rejectionReason,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary text-white",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)))
            }, " Guardar "),
            _cache[29] || (_cache[29] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              "data-bs-dismiss": "modal"
            }, " Cerrar ", -1 /* HOISTED */))
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}